import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import colors from '../../../../../util/colors';
import {strings} from '../../../../../util/strings';
import {deepStringObjectMerger} from '../../../../../util/utility';
import * as fonts from '../../../../../util/fonts';

import './styles.scss';
import {Column} from '../../../../layout';
import Icon from '../../../../icon';
import {Icons} from '../../../../../util/icons';

interface NonCustomerCardProps {
  labels: typeof strings.pt.virtualCard;
  buStyles: any;
}

function NonCustomerCard({
  labels: labelsFromRedux,
  buStyles,
}: NonCustomerCardProps) {
  const labels = deepStringObjectMerger(
    strings.pt.virtualCard,
    labelsFromRedux,
  );

  return (
    <Column
      onClick={() => window.open('https://advancemediacao.pt/', '_blank')}
      className="non-customer-card-container app-header-card"
      style={{
        ...fonts.M,
        color: colors.white,
        background:
          process.env.REACT_APP_DEFAULT_TENANT_ALIAS === 'RS'
            ? 'linear-gradient(#b31c1a, #95050a)'
            : `linear-gradient(${buStyles?.primaryColor}, ${buStyles?.secondaryColor}#20)`,
      }}>
      <Icon
        className="non-customer-card-plus-icon"
        name={Icons.CIRCLE_PLUS}
        width="55"
        height="55"
        changeViewbox
        viewBox={'0 0 24 24'}
      />
      {labels?.VCNeedInsurance_subtitle}
    </Column>
  );
}

const mapStateToProps = ({strings, globalStyles}: any) => ({
  labels: strings.value.pt.virtualCard ?? {},
  buStyles: globalStyles.value,
});

export default compose(connect(mapStateToProps)(NonCustomerCard));
